import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { CALENDAR_YEAR } from '../models/CALENDAR_YEAR';
@Injectable()
export class UtilService {

  constructor() { }

  findEra(date: any) {
    if (date) {
      if (date instanceof Date) {
        date = moment(date);
      }
      for (let i = CALENDAR_YEAR.length - 1; i > 0; i--) {
        if (date.isSameOrAfter(moment(CALENDAR_YEAR[i].Start, 'YYYYMMDD'))) {
          return CALENDAR_YEAR[i];
        }
      }
    }
    return CALENDAR_YEAR[0];
  }

  stringToNumber(str): number {
    if (str == null) {
      return 0;
    }
    if (typeof (str) == 'string') {
      return Number(str.replace(/[^0-9\.-]+/g, ''));
    }
    return str;
  }

  padNumber(input: string, n: number): string {
    if (input == null) {
      return '';
    }
    let s = input;
    while (s.length < n) {
      s = '0' + s;
    }
    return s;
  }

  setStringdate(formetdate: any, date: any): string {
    return moment(date).format(formetdate);
  }

  getDate(date: any, formetdate: any): Date {
    const myDate: Date = moment(date, formetdate).toDate();
    return myDate;
  }
  getUTF8Length(str: string, wordstr: number): { count: number; strCount: number; } {
    if (!str) {
      return { count: 0, strCount: 0 }
    }
    let ch;
    let count: number = 0;
    let countTxt: number = 0;
    for (let i = 0; i < str.length; i++) {
      ch = str.charCodeAt(i);

      if ((ch >= 0x0 && ch < 0x81) || (ch == 0xf8f0) || (ch >= 0xff61 && ch < 0xffa0) || (ch >= 0xf8f1 && ch < 0xf8f4)) {
        count += 1;
      } else {
        count += 2;
      }
      // if (str.match(this.jpHalf)) {
      //   count += 1;
      // } else if (str.match(this.jpFull)) {
      //   count += 2;
      // }

      if (count <= wordstr) {
        countTxt++;
      }

    }

    return { count: count, strCount: countTxt }

  }

  getNumberThousandSeparate(input: number): string {
    return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/util.service.ts